import axios from 'axios';

const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5001/api');
const SITE_TOKEN_KEY = 'site_token';
const LEGACY_TOKEN_KEY = 'token';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(SITE_TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY);
  if (token) {
    localStorage.setItem(SITE_TOKEN_KEY, token);
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Let axios set multipart boundary — manual Content-Type breaks file uploads.
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

export const getMediaUrl = (filePath) => {
  if (!filePath) return '';
  if (/^https?:\/\//i.test(filePath)) return filePath;
  const normalized = String(filePath).replace(/\\/g, '/').replace(/^\/+/, '');
  const rel = normalized.replace(/^uploads\//, '');
  const apiBase =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5001/api');
  return `${apiBase.replace(/\/$/, '')}/media/${rel}`;
};

export default api;

